/**
 * Created by tomere on 05/09/2017.
 */
export default class BreadcrumbsComponent {
	constructor() {
		this.template = require('./jf.breadcrumbs.view.html');
		this.bindings = {
			onCrumbClick: '&?',
			pathElements: '<'
		};
	}
}

BreadcrumbsComponent.META = {
	name: 'breadcrumbs'
};



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-breadcrumbs/jf.breadcrumbs.component.js